import { Box, styled, Typography, TypographyProps } from '@mui/material'

export const LinksContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(8),
  flexDirection: 'column',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}))

export const Title = styled((props) => <Typography component="h1" {...props }/>)<TypographyProps>(({ theme }) => ({
  ...theme.typography.h2,
  textAlign: 'center',
}))

export const Section = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  textTransform: 'capitalize',
  margin: theme.spacing(4, 0),
  borderBottom: '1px solid #fff',
  paddingBottom: theme.spacing(1),
}))

export const Path = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  textTransform: 'capitalize',
  margin: theme.spacing(2, 0),
  color: theme.palette.primary[400],
  cursor: 'pointer',
}))
